import React, { useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { toast } from "sonner";
import { Mail, Loader2, CheckCircle2 } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await axios.post(`${API}/auth/forgot-password`, { email });
      setSent(true);
    } catch (err) {
      toast.error(err.response?.data?.detail || "Something went wrong");
    } finally { setLoading(false); }
  };

  return (
    <div className="mx-auto flex min-h-[70vh] max-w-md items-center px-6 py-10">
      <div className="w-full rounded-3xl bg-white p-8 card-shadow">
        <div className="flex items-center gap-2">
          <img src="/logo.png" alt="EasyStay" className="h-9 w-9 rounded-xl object-cover" />
          <span className="font-display text-xl font-bold text-slate-900">Easy<span className="text-copper">Stay</span></span>
        </div>

        {sent ? (
          <div data-testid="forgot-sent-panel" className="mt-6 text-center">
            <CheckCircle2 className="mx-auto h-12 w-12 text-green-600" />
            <h1 className="mt-4 font-display text-2xl font-bold text-slate-900">Check your inbox</h1>
            <p className="mt-2 text-sm text-slate-600">If an account exists for <strong>{email}</strong>, we&apos;ve prepared a password-reset link. Check the app inbox / your email in a few minutes.</p>
            <Link to="/login" className="btn-outline mt-6 inline-block text-sm">Back to sign in</Link>
          </div>
        ) : (
          <>
            <h1 className="mt-6 font-display text-3xl font-bold text-slate-900">Forgot password?</h1>
            <p className="mt-1 text-sm text-slate-600">Enter your email and we&apos;ll send you a reset link.</p>
            <form onSubmit={submit} className="mt-6 space-y-3">
              <div>
                <label className="text-xs uppercase tracking-widest text-slate-500">Email</label>
                <div className="mt-1 flex items-center gap-2 rounded-xl border border-slate-200 bg-slate-50 px-3 focus-within:border-copper focus-within:bg-white">
                  <Mail className="h-4 w-4 text-slate-400" />
                  <input data-testid="forgot-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
                    placeholder="you@example.com" className="w-full bg-transparent py-3 text-sm outline-none" />
                </div>
              </div>
              <button data-testid="forgot-submit" type="submit" disabled={loading} className="btn-primary w-full text-sm">
                {loading ? <Loader2 className="mx-auto h-4 w-4 animate-spin" /> : "Send reset link"}
              </button>
            </form>
            <div className="mt-6 text-center text-xs text-slate-500">
              Remembered it? <Link to="/login" className="font-semibold text-copper hover:underline">Back to sign in</Link>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
